import React from "react";
import { Typography } from "@mui/material";

import SectionBox from "elements/SectionBox";
import DiagnosticForm from "./DiagnosticForm";
import DiagnosticDetail from "./DiagnosticDetail";

/**
 * The `DiagnosticProfile` component displays a diagnostic profile for a client.
 * @param {Object} props - The props of the component
 * @param {Boolean} props.editMode - The edit mode of the component
 * @param {Object} props.diagnosticValues - The diagnosis values of the component
 * @param {Object} props.listOfDiagnosis - The list of diagnosis of the component
 * @returns {React.ReactElement} The DiagnosticProfile component
 */
const DiagnosticProfile = ({ editMode, diagnosticValues, listOfDiagnosis }) => {
  return (
    <SectionBox
      sx={{ padding: "32px 0 0" }}
      title="Diagnostic Profile"
      description={
        <Typography component="p" variant="body2">
          Essential diagnostic and treatment information used to analyze client outcomes and measure
          program effectiveness.
        </Typography>
      }
    >
      {editMode ? (
        <DiagnosticForm listOfDiagnosis={listOfDiagnosis} />
      ) : (
        <DiagnosticDetail diagnosticValues={diagnosticValues} listOfDiagnosis={listOfDiagnosis} />
      )}
    </SectionBox>
  );
};

export default DiagnosticProfile;
